'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('./styleInject.js');

var css_248z = ".BlockEdd-module_container__M1oSm{align-items:center;display:flex;flex-direction:row;margin-bottom:.25rem}";
var styles = {"container":"BlockEdd-module_container__M1oSm"};
styleInject["default"](css_248z, '5fd58445-34e0-4075-a58c-67e7095294b5');

exports["default"] = styles;
